/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormaProrogaVoucher } from './forma-proroga-voucher';


export interface VoucherProrogaDTO { 
    forma?: FormaProrogaVoucher;
    giorni?: number;
    data?: string;
    /**
     * Assente se il voucher non aveva ancora una scadenza (decorrenza CONSEGNA)
     */
    scadenza_precedente?: string;
    scadenza_nuova?: string;
    motivo?: string;
    operatore?: string;
    data_proroga?: string;
}



